import React, { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Link as MuiLink } from '@mui/material';

type MuiLinkProps = Omit<Parameters<typeof MuiLink>[0], 'component' | 'href'>;

type Props = {
  href: string;
  replace?: boolean;
  backLinkHref?: string;
} & MuiLinkProps;

export default function Link({ href, backLinkHref, ...props }: Props): JSX.Element {
  const state = useMemo(() => {
    if (typeof backLinkHref !== 'string') {
      return undefined;
    }
    return { backLinkHref };
  }, [backLinkHref]);
  return <MuiLink component={RouterLink} to={href} href={href} state={state} {...props} />;
}
